import router from 'page';
import routes from './routes';
import { page, path as currentPath } from '../store/navigation';
export default () => {
    routes.forEach(({ path, component }) => {
        router(path, ({ pathname }, next) => {
            currentPath.set(pathname);
            next();
        }, () => {
            page.set(component);
        });
    });
    router.start();
};
